import { onChangedAsync } from '@/backend/features/background-check/settings/callbacks/onChangedAsync';
import { isBackgroundCheckConfigUpdated } from '@/backend/features/background-check/utils/backgroundCheckTypeChanges';
import { defineSettingMap } from '@juvare/platform-sdk-react/backend/features/editable-settings/shared';
import {
    backgroundCheckQuotaForm,
    backgroundCheckTestForm,
    defaultBackgroundCheckConfig,
    defaultBackgroundCheckQuota,
    defaultBackgroundCheckTest,
} from '../defaults';

export const backgroundCheckSettingMap = defineSettingMap({
    backgroundCheckConfig: {
        type: 'json',
        description: 'Background Check Config',
        defaultValue: defaultBackgroundCheckConfig,
        group: 'system-admin',
        onScheduleChangedAsync: (_context, params) => {
            if (params.action === 'update') {
                return isBackgroundCheckConfigUpdated(params.prevData, params.data)?.length > 0;
            }

            return false;
        },
        onChangedAsync: onChangedAsync,
    },
    backgroundCheckQuota: {
        type: 'json',
        description: 'Background Check Quota',
        defaultValue: defaultBackgroundCheckQuota,
        group: 'system-admin',
        form: backgroundCheckQuotaForm,
    },
    backgroundCheckTest: {
        type: 'json',
        description: 'Background Check Test',
        defaultValue: defaultBackgroundCheckTest,
        group: 'system-admin',
        form: backgroundCheckTestForm,
    },
});

export type BackgroundCheckSettingMapType = typeof backgroundCheckSettingMap;
